import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'

import './assets/css/style.scss'

if (process.env.VUE_APP_KNOWN_DATE) {
  Date.now = () => Number(process.env.VUE_APP_KNOWN_DATE)
}

Vue.config.productionTip = false

Vue.use(Notifications)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
